import React from 'react';

export const ScenarioSelectionIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <rect
                    width="1.323"
                    height="1.323"
                    x="0.397"
                    y="2.249"
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    ry="0.331"
                ></rect>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="0.265"
                    d="M2.674 0.516H2.939V2.104H2.674z"
                    transform="rotate(45)"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="0.265"
                    d="M1.177 -3.6H1.4420000000000002V-2.013H1.177z"
                    transform="rotate(135)"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    d="M2.117 2.646H4.763V3.175H2.117z"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.498 2.117l1.323.793-1.323.794z"
                ></path>
                <rect
                    width="0.529"
                    height="0.529"
                    x="2.117"
                    y="0.794"
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    opacity="0.75"
                    ry="0.265"
                ></rect>
                <rect
                    width="1.323"
                    height="1.323"
                    x="0.397"
                    y="0.397"
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    opacity="0.75"
                    ry="0.331"
                ></rect>
                <rect
                    width="0.529"
                    height="0.529"
                    x="2.91"
                    y="0.794"
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    opacity="0.75"
                    ry="0.265"
                ></rect>
                <rect
                    width="0.529"
                    height="0.529"
                    x="3.704"
                    y="0.794"
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    opacity="0.75"
                    ry="0.265"
                ></rect>
                <rect
                    width="0.529"
                    height="0.529"
                    x="2.117"
                    y="4.498"
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    opacity="0.75"
                    ry="0.265"
                ></rect>
                <rect
                    width="0.529"
                    height="0.529"
                    x="2.91"
                    y="4.498"
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    opacity="0.75"
                    ry="0.265"
                ></rect>
                <rect
                    width="0.529"
                    height="0.529"
                    x="3.704"
                    y="4.498"
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    opacity="0.75"
                    ry="0.265"
                ></rect>
                <path
                    fill="none"
                    fillOpacity="1"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.632.499l.93.56-.93.56z"
                    opacity="0.75"
                ></path>
                <path
                    fill="none"
                    fillOpacity="1"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.632 4.203l.93.56-.93.56z"
                    opacity="0.75"
                ></path>
                <rect
                    width="1.323"
                    height="1.323"
                    x="0.397"
                    y="4.101"
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    opacity="0.75"
                    ry="0.331"
                ></rect>
            </g>
        </svg>
    );
};
